module.exports = __webpack_public_path__ + "static/media/AsistanceAnswer.1c9a8cc2.svg";